module.exports = __webpack_public_path__ + "img/ks.ff52a0bd.png";